import TeacherRequest from './TeacherRequest';

export default TeacherRequest;
